import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";


const Boxcard = () => {
const [departmentDetails, setDepartmentDetails] = useState([]);
const [loading, setLoading] = useState(false);
const navigate = useNavigate();

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("No auth token found");
      navigate("/login");
    }
    

    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-data-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch tasks");

      const result = await response.json();
      setLoading(false);
      setDepartmentDetails(result.topUsers || []);
    } catch (err) {
      console.error("Error fetching tasks:", err);
    }
  };


  const getCardColor = (index) => {
    const colors = ["bg-red-50", "bg-green-50", "bg-teal-50", "bg-pink-50"];
    return colors[index % colors.length];
  };
  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
        Top Employees
      </h2>

      <ul className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6">
        {departmentDetails.map((d, index) => (
          <li
            key={d.id}
            className={`flex flex-col justify-between rounded-2xl shadow-md p-5 border border-gray-100 hover:shadow-xl transition-all duration-300 ${getCardColor(
              index
            )}`}
          >
            <div className="flex items-center gap-4 mb-4">
              <img
                src={d.avatar}
                alt={d.name}
                className="w-12 h-12 rounded-full border-2 border-white shadow-sm"
              />
              <div>
                <h3 className="text-lg font-semibold text-gray-800 capitalize">
                  {d.name}
                </h3>
                <p className="text-sm text-gray-600">{d.designation}</p>
                <p className="text-sm text-gray-500">{d.department_name}</p>
                <p className="text-xs text-gray-500">{d.email}</p>
              </div>
            </div>

            <div className="flex justify-around text-center">
              <div>
                <p className="text-xs text-gray-500">Total Tasks</p>
                <p className="text-lg font-bold text-gray-800">{d.totalTask}</p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Pending</p>
                <p className="text-lg font-bold text-yellow-600">
                  {d.pendingTask}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Completed</p>
                <p className="text-lg font-bold text-green-600">
                  {d.completedTask}
                </p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Boxcard;
